import React from "react";
import { Box, Typography } from "@mui/material";

export default function Footer() {
  return (
    <Box sx={{}}>
      <Box
        sx={{
          background: "#f5f5f5",
          textAlign: "center",
          py: 2,
        }}
      >
        <Typography variant="body2" sx={{ color: "#555" }}>
          © 2025 Safe Place. All Rights Reserved
        </Typography>
      </Box>
    </Box>
  );
}
